"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRole = void 0;
// eslint-disable-next-line import/prefer-default-export
var getRole_1 = require("./getRole");
Object.defineProperty(exports, "getRole", { enumerable: true, get: function () { return __importDefault(getRole_1).default; } });
